import React from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
// import { useGetOrderDetailsQuery } from '../redux/api/roomBookingApi';
import { useGetOrderDetailsQuery } from '../redux/api/roomBookingApi'
const OrderDetail = () => {
    const { id } = useParams();
    const location = useLocation();
    const isAdminView = location.pathname.startsWith('/admin');
    const backLink = isAdminView ? '/admin/payments' : '/profile';
    const { data, isLoading, error } = useGetOrderDetailsQuery(id);

    if (isLoading) return <div className="container py-5 text-center">Loading Order Details...</div>;

    if (error) return (
        <div className="container py-5 text-center">
            <h3 className="text-danger">Error fetching order details</h3>
            <p>{error?.data?.message || 'Access Denied or Order Not Found'}</p>
            <Link to={backLink} className="btn btn-primary">Back to {isAdminView ? 'Payments' : 'Profile'}</Link>
        </div>
    );

    const { order } = data || {};
    const { bookingDetails } = order || {};

    // Helper to format date
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleString();
    };

    return (
        <div className="space-top space-extra-bottom">
            <div className="container">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2>Your Order Details</h2>
                    <Link to={backLink} className="btn btn-secondary">
                        <i className="fas fa-arrow-left me-2"></i> Back
                    </Link>
                </div>

                <div className="row">
                    {/* Order Details Column */}
                    <div className="col-md-6 mb-4">
                        <div className="card h-100 shadow-sm">
                            <div className="card-header bg-primary text-white">
                                <h5 className="mb-0 text-white">Order Info</h5>
                            </div>
                            <div className="card-body">
                                <table className="table table-borderless">
                                    <tbody>
                                        <tr>
                                            <th>ID:</th>
                                            <td>{bookingDetails?.booking_id || order?.booking_id}</td>
                                        </tr>
                                        <tr>
                                            <th>Status:</th>
                                            <td>
                                                <span className={`badge bg-${order?.pay_status === 'completed' ? 'success' : order?.pay_status === 'pending' ? 'warning' : 'danger'}`}>
                                                    {(order?.pay_status || 'Unknown').toUpperCase()}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Date:</th>
                                            <td>{formatDate(order?.created_date)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* Shipping / Guest Info Column */}
                    <div className="col-md-6 mb-4">
                        <div className="card h-100 shadow-sm">
                            <div className="card-header bg-info text-white">
                                <h5 className="mb-0 text-white">Shipping Info (Guest Details)</h5>
                            </div>
                            <div className="card-body">
                                <table className="table table-borderless">
                                    <tbody>
                                        <tr>
                                            <th>Name:</th>
                                            <td>{order?.name}</td>
                                        </tr>
                                        <tr>
                                            <th>Phone No:</th>
                                            <td>{order?.contact_no}</td>
                                        </tr>
                                        <tr>
                                            <th>Address:</th>
                                            <td>{order?.address || bookingDetails?.address || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <th>Email:</th>
                                            <td>{order?.email_id}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {/* Payment Info Column */}
                    <div className="col-md-6 mb-4">
                        <div className="card h-100 shadow-sm">
                            <div className="card-header bg-success text-white">
                                <h5 className="mb-0 text-white">Payment Info</h5>
                            </div>
                            <div className="card-body">
                                <table className="table table-borderless">
                                    <tbody>
                                        <tr>
                                            <th>Status:</th>
                                            <td>
                                                <span className={`badge bg-${order?.pay_status === 'completed' ? 'success' : 'danger'}`}>
                                                    {order?.pay_status === 'completed' ? 'Paid' : 'Not Paid'}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Method:</th>
                                            <td>{order?.pay_id === 'cash' ? 'Cash' : 'Online'}</td>
                                        </tr>
                                        <tr>
                                            <th>Method Detail:</th>
                                            <td>{order?.pay_array?.payment_method?.upi?.upi_id || order?.pay_array?.payment_method?.card?.card_number || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <th>Transaction ID:</th>
                                            <td>{order?.transaction_id || 'Nill'}</td>
                                        </tr>
                                        <tr>
                                            <th>Amount Paid:</th>
                                            <td>₹{order?.amount}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* Order Items Column */}
                    <div className="col-md-6 mb-4">
                        <div className="card h-100 shadow-sm">
                            <div className="card-header bg-warning text-dark">
                                <h5 className="mb-0">Order Items</h5>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Item Name</th>
                                                <th>Qty</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {order?.order_items && order.order_items.length > 0 ? (
                                                order.order_items.map((item, idx) => (
                                                    <tr key={idx}>
                                                        <td>{item.seva_name || item.name || 'Item'}</td>
                                                        <td>{item.qty || 1}</td>
                                                        <td>₹{item.seva_amount || item.amount}</td>
                                                    </tr>
                                                ))
                                            ) : bookingDetails ? (
                                                <tr>
                                                    <td>{bookingDetails?.room_type?.name || 'Room Booking'}</td>
                                                    <td>{bookingDetails?.no_of_rooms || 1}</td>
                                                    <td>₹{order?.amount}</td>
                                                </tr>
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center">No Items Found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderDetail;
